import React from 'react';
import { Link } from 'react-router-dom';
import PublicPageLayout from '../components/landing-page/PublicPageLayout';
import { blogPosts } from './blogData';

export default function BlogPage() {
  return (
    <PublicPageLayout title='Blog' subtitle='Insights on pricing strategy, experimentation, and growth operations.'>
      <div className='space-y-4'>
        {blogPosts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className='block rounded-xl border border-gray-200 bg-white p-5 shadow-sm ring-1 ring-black/5 transition-shadow hover:border-amber-200/80 hover:shadow-md hover:ring-amber-200/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-700 dark:border-gray-200 dark:bg-white dark:shadow-md dark:ring-gray-200/80 dark:hover:border-amber-300/80 dark:hover:ring-amber-300/30'
          >
            <article>
              <p className='text-xs uppercase tracking-wider text-gray-500'>{post.publishedAt}</p>
              <h2 className='mt-1 text-xl font-semibold text-gray-900'>{post.title}</h2>
              <p className='mt-2 text-sm text-gray-600'>{post.excerpt}</p>
            </article>
          </Link>
        ))}
      </div>
    </PublicPageLayout>
  );
}
